module.exports = __webpack_public_path__ + "res/ic_link_c.c96a3a82be83e642554d5b7b85748f13.png";